
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              올딩스 로지스
            </h3>
            <p className="text-gray-300 mb-4">
              편안한 물류친구가 되겠습니다.<br />
              국내와 글로벌 이커머스 물류에 특화된<br />
              독보적 3PL 서비스를 제공합니다.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">연락처</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                청주시 청원구 내수읍 충청대로 539
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                010-3099-5677
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                ydhan9@naver.com
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">서비스</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link to="/about" className="hover:text-white transition-colors cursor-pointer">
                  회사소개
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors cursor-pointer">
                  서비스소개
                </Link>
              </li>
              <li>
                <Link to="/consultation" className="hover:text-white transition-colors cursor-pointer">
                  상담예약
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors cursor-pointer">
                  문의하기
                </Link>
              </li>
              <li>
                <Link to="/location" className="hover:text-white transition-colors cursor-pointer">
                  오시는길
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 올딩스 로지스. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm mt-2 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
